import template from 'uri-templates'

export const ADVICE_DETAIL = template('/advice-request/detail?adviceId={adviceId}')
export const ADVICE_REQUEST_FORM = '/advice-requests/form'
export const ADVICE_REQUEST_FORM_FOREIGN = '/advice-requests/form-foreign'
export const ADVICE_REQUEST_FORM_DETAIL = template('/advice-requests/form?adviceId={adviceId}')
export const SEARCH = template('/search/{searchTerm}')
